import { Component } from '@angular/core';

@Component({
    selector: 'app-violations-list',
    templateUrl: './violations-list.component.html',
    styleUrls: ['./violations-list.component.css'],
    standalone: false
})
export class ViolationsListComponent {
}
